<template lang="pug">
div
  div.d-flex.justify-center.mt-16(v-if="isFetching")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

  template(v-else)
    v-row(no-gutters :style="`min-height: ${viewHeight};`")
      v-col.px-8.shrink.white
        div.sticky(style="width: 200px; top: 106px;")
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 0 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(0)") Settings
          //- .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 1 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(1)") Deliverance
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 1 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(1)") QR Code & Link
    
      v-col.grow.neutral200
        v-container.pa-8(fluid style="max-width:1200px")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="goBack" height)
                v-icon(color="basic800" :size="24") mdi-arrow-left
            v-col.ml-3
              .text-2xl.font-semibold.neutral700--text Edit loyalty program

          v-window(v-model="step" touchless)
            v-window-item(:value="0")
              loyalty-stamps-settings(v-if="settings && settings.loyalty_system === 'stamps'" ref="settings" @updated="isLoading = false" @error="isLoading = false")
              loyalty-points-settings(v-if="settings && settings.loyalty_system === 'points'" ref="settings" @updated="isLoading = false" @error="isLoading = false")
            //- v-window-item(:value="1")
              loyalty-deliverance
            v-window-item(:value="1")
              loyalty-qr-code-link(ref="qrcodelink" @updated="isLoading = false" @error="isLoading = false")

          v-footer.white.py-3.px-10(app inset padless elevation="3")
            v-spacer
            y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="goBack")
            y-button(label="Save" color="neutral700" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LoyaltyStampsSettings from '@/components/clinic/marketing/LoyaltyStampsSettings.vue'
import LoyaltyPointsSettings from '@/components/clinic/marketing/LoyaltyPointsSettings.vue'
import LoyaltyDeliverance from '@/components/clinic/marketing/LoyaltyDeliverance.vue'
import LoyaltyQrCodeLink from '@/components/clinic/marketing/LoyaltyQrCodeLink.vue'

export default {
  name: 'LoyaltySettings',
  components: { LoyaltyStampsSettings, LoyaltyPointsSettings, LoyaltyDeliverance, LoyaltyQrCodeLink },
  data () {
    return {
      isLoading: false,
      isFetching: false,
      step: 0,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      settings: 'marketing/getMarketingSettings',
      displaySize: 'ui/getDisplaySize'
    }),
    viewHeight () {
      switch (this.displaySize) {
        case 'xx-small':
          return '130vh'
        case 'x-small':
          return '114vh'
        case 'small':
          return '106vh'
        case 'medium':
          return '92vh'
        case 'large':
          return '81vh'
        case 'x-large':
          return '81vh'
        default:
          return '81vh'
      }
    }
  },
  mounted () {
    this.fetchLoyaltySettings()
    this.fetchSettings()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchLoyaltySettings () {
      this.isFetching = true
      this.$axios.get(`/loyalty/${this.company.slug}`)
        .then(resp => {
          this.$store.commit('marketing/setLoyaltySettings', resp.data)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchSettings () {
      this.$axios.get(`/marketing/${this.company.slug}`)
        .then(resp => {
          this.$store.commit('marketing/setMarketingSettings', resp.data)
        })
        .catch(() => {})
    },
    fetchOffers () {
      this.isFetching = true
      let params = { expand: 'purchase_products,free_products' }
      this.$axios.get(`/marketing/${this.company.slug}/offers/${this.id}`, params)
        .then(resp => {
          this.$store.commit('marketing/setOffer', resp.data)
          this.fetchDeliverance(resp.data.id)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchDeliverance (id) {
      this.$axios.get(`/marketing/${this.company.slug}/offers/${id}/blasts`)
        .then(resp => {
          if (resp.data.results.length) {
            this.$store.commit('marketing/setBlasts', resp.data.results)
          }
        })
        .catch(() => {})
    },
    saveData () {
      if (this.step === 0) {
        this.isLoading = true
        this.$refs.settings.saveData()
      }
      if (this.step === 1) {
        this.isLoading = true
        this.$refs.qrcodelink.saveData()
      }
    },
    updateSetOffers (id) {
      this.isLoading = false
      this.step = 1
      if (!this.id) {
        this.$router.push(`/admin/clinic/marketing/offer/create/${id}`)
      }
    },
    goToWindow (step) {
      if (this.step !== step) {
        this.step = step
      }
    },
    goBack () {
      this.$router.push('/admin/clinic/marketing')
    },
  },
  beforeDestroy () {
    this.$store.commit('marketing/resetLoyaltySettings')
  }
}
</script>

<style scoped>
</style>